import { render, staticRenderFns } from "./ContactTags.vue?vue&type=template&id=371bac1b&"
import script from "./ContactTags.vue?vue&type=script&lang=js&"
export * from "./ContactTags.vue?vue&type=script&lang=js&"
import style0 from "./ContactTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports